export interface LocatePreferences {
    warningPreferences: {
        showAutoAcceptWarning: boolean;
        showIsPriceOverOneWarning: boolean;
        showNoCancelPossibleWarning: boolean;
        showETBWarning: boolean;
    };
}

export const defaultLocatePreferences: LocatePreferences = {
    warningPreferences: {
        showAutoAcceptWarning: true,
        showIsPriceOverOneWarning: true,
        showNoCancelPossibleWarning: true,
        showETBWarning: true,
    },
};

export const LOCATE_PREFERENCES_KEY = 'locate_preferences_1f2b3c';
